module.exports = __webpack_public_path__ + "img/cmc.eadb4f63.png";